module.exports = __webpack_public_path__ + "static/media/dwt-06.7ffe94b5.jpg";